/**
 * Created by Julio Perez on 9/20/2016.
 */

import * as path from '../../shared/js/ga-tracking-path';

export default class NavLinksStripController{
    constructor(
        $state,
        navLinksStripService
    ){

        let vm = this;


        vm.navLinksStripService = navLinksStripService;

        vm.navLinks = vm.navLinksStripService.getNavLinks();

        vm.sectionSelected = "q";
        vm.currentButtonIndex = 5;

        vm.buttonSelected=(idx)=>{

            vm.currentButtonIndex = idx;

        }

        vm.isButtonSelected = (idx) =>{
            let bool;

            if(vm.currentButtonIndex === idx){
                bool = true;
            }else{
                bool = false;
            }

            return bool;

        };

        vm.changeSelection = (selection) =>{

            if(path.isTracking){
                ga('send', {
                    hitType: 'event',
                    eventCategory: 'VisApps',
                    eventLabel: path.emiENV,
                    eventAction: path.emiENV + '-clicked-' + selection
                });

                ga('send', {
                    hitType: 'screenview',
                    appName: path.emiENV,
                    screenName: path.emiENV + '-clicked-' + selection
                });
            }else {
                console.log("TEST: ", path.emiENV + '-clicked-' + selection);
            }

        };




    }


}

NavLinksStripController.$inject =[
    '$state',
    'navLinksStripService'
];


// WEBPACK FOOTER //
// ./src/app/ui/nav-links-strip/nav-links-strip.controller.js